import Box from "@mui/material/Box";

type StepTrackerProps = {
  totalSteps: number;
  currentStep: number;
  activeColor?: string;
  inactiveColor?: string;
  barHeight?: number;
  gap?: number;
};

const StepTracker: React.FC<StepTrackerProps> = ({
  totalSteps,
  currentStep,
  activeColor = "primary.main",
  inactiveColor = "divider",
  barHeight = 6,
}) => {
  return (
    <Box display="flex" justifyContent="center">
      {[...Array(totalSteps)].map((_, index) => (
        <Box
          key={index}
          sx={{
            flex: 1,
            height: barHeight,
            backgroundColor: index < currentStep ? activeColor : inactiveColor,
            borderRadius: 4,
            transition: "opacity 0.3s ease-in-out",
            opacity: index < currentStep ? 1 : 0.3,
            marginX: 0.5,
          }}
        />
      ))}
    </Box>
  );
};

export default StepTracker;
